import { render } from "./sidebar_context.html?vue&type=template&id=208ea02f&external"
import script from "./sidebar_context.js?vue&type=script&lang=js&external"
export * from "./sidebar_context.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__